import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { motion } from 'framer-motion';

const Header = () => {
  const location = useLocation();
  
  return (
    <motion.header 
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      className="bg-[#2b6777] shadow-lg"
    >
      <div className="container mx-auto px-4 py-4">
        <div className="flex items-center">
          <Link to="/" className="flex items-center gap-3 hover:opacity-90 transition-opacity">
            <img 
              src="https://letcheck.b-cdn.net/944/bild-logo-final-dunkel-1726774068395.png" 
              alt="Logo" 
              className="h-10 w-auto"
            />
            <h1 className="text-2xl font-bold text-white font-rubik">
              Buchstabensalat
            </h1>
          </Link>
        </div>
      </div>
    </motion.header>
  );
};

export default Header;